import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { Message } from 'primeng/message';
import { FormsModule } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import { ApiService } from '../../_utils/api/api.service';
import { SeoService } from '../../_utils/seo/seo.service';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss',
    imports: [CommonModule, TranslocoDirective, Bind, Button, Dialog, Message, FormsModule, InputText, Textarea, UpperCasePipe]
})
export class ErrorPageComponent {
  errorCode: string = 'GENERAL';
  errorMessage: string | null = null;
  loading: boolean = false;
  error: string | null = null;
  message: string | null = null;
  contactModalVisible: boolean = false;
  config: any = {};
  data: any = {};
  contactFormModel: any = {};

  constructor(private seoService: SeoService, private translocoService: TranslocoService, private route: ActivatedRoute, protected router: Router, private apiService: ApiService) {
    this.route.queryParams.subscribe((params) => {
      if (params['code']) {
        this.errorCode = params['code'];
      }

      if (params['message']) {
        this.errorMessage = params['message'].replace('Error: ', '');
      }

      this.translocoService.selectTranslate(['form.send_message_object', 'form.message_textarea', 'error', 'api_error.general']).subscribe((messages) => {
        this.contactFormModel = {
          object: messages[0],
          text: messages[1]
        };

        if (this.errorCode === 'APP_KEY_NOT_FOUND') {
          this.seoService.setSeo({
            title: messages[2],
            description: messages[3],
            image: '',
            url: this.router.serializeUrl(this.router.createUrlTree(['/error'], { queryParams: params }))
          });
          return;
        }

        this.apiService.getCompany().subscribe({
          next: (data) => {
            this.config = data.config;
            this.data = data.data;
            this.seoService.setSeo({
              title: messages[2],
              description: messages[3],
              image: data.data.image || data.data.logo,
              url: data.data.pwa_url + this.router.serializeUrl(this.router.createUrlTree(['/error'], { queryParams: params }))
            });
          },
          error: (error) => {
            console.error(error);
          }
        });
      });
    });
  }

  goHome(): void {
    if (typeof window != 'undefined') {
      window.location.reload();
      window.location.href = '/';
    }
  }

  openContactModal(): void {
    this.message = null;
    this.error = null;
    this.contactModalVisible = true;
  }

  sendContactForm(): void {
    this.loading = true;
    this.error = null;
    this.message = null;
    this.translocoService.selectTranslate(['form.message_sent', 'form.message_error']).subscribe((messages) => {
      this.apiService.contactCompany(this.contactFormModel).subscribe({
        next: (response) => {
          this.loading = false;
          this.message = messages[0];
        },
        error: (error) => {
          this.loading = false;
          console.error(error);
          this.error = messages[1];
        }
      });
    });
  }
}
